import { render, staticRenderFns } from "./arrears.vue?vue&type=template&id=7cf3642b"
import script from "./arrears.vue?vue&type=script&lang=js"
export * from "./arrears.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports